<script lang="ts" setup>
import { SEARCH_RESULT_TYPES } from '~/constants/searchResultTypes';

interface SearchResultImage {
  conversions?: {
    thumb_80?: string;
    thumb_url_65?: string;
  };
  conversions_webp?: {
    thumb_80?: string;
    thumb_url_180?: string;
  };
  url: string;
}

const {
  image,
  name = '',
  price = 0,
  type = '',
  url = '',
} = defineProps<{
  image?: SearchResultImage;
  name?: string;
  price?: number;
  type?: string;
  url?: string;
}>();

const searchStore = useSearchStore();
const hasImageColumn = computed(() => type !== SEARCH_RESULT_TYPES.content);
</script>

<template>
  <AppLink
    :to="url"
    :class="{ 'search-results-list-item--without-image': !hasImageColumn }"
    class="search-results-list-item"
    @click="searchStore.setSearchHistory({ name, url })"
  >
    <template v-if="hasImageColumn && image">
      <picture v-if="type === SEARCH_RESULT_TYPES.brand">
        <source
          :srcset="image.conversions_webp?.thumb_80"
          type="image/webp"
        />

        <source
          :srcset="image.conversions?.thumb_80"
          type="image/jpeg"
        />

        <img
          :src="image.url"
          alt="image"
          class="search-results-list-item__image"
        />
      </picture>

      <picture v-else>
        <source
          :srcset="image.conversions_webp?.thumb_url_180"
          type="image/webp"
        />

        <source
          :srcset="image.conversions?.thumb_url_65"
          type="image/jpeg"
        />

        <img
          :src="image.url"
          alt="image"
          class="search-results-list-item__image"
        />
      </picture>
    </template>

    <SvgoNoPhotoSmall
      v-else-if="hasImageColumn"
      :font-controlled="false"
      class="w-10 h-10"
      filled
    />

    <div class="flex flex-col gap-1 py-2">
      <div v-html="highlightTextOccurrence(name, searchStore.searchQuery)" />

      <div
        v-if="type === SEARCH_RESULT_TYPES.offer"
        class="flex gap-3"
      >
        <span class="font-bold">
          {{ `${price.toLocaleString('ru-RU')} ₽` }}
        </span>
      </div>
    </div>
  </AppLink>
</template>

<style lang="scss" scoped>
.search-results-list-item {
  display: grid;
  grid-template-columns: 48px 1fr;
  gap: 16px;
  align-items: center;
  padding: 4px 0;
  border-bottom: 1px solid $black-20;
  font-size: 14px;

  &--without-image {
    grid-template-columns: 1fr;
  }

  &:last-of-type {
    padding-bottom: 0;
  }

  &__image {
    justify-self: center;
    object-fit: contain;
    min-height: 40px;
    max-height: 62px;
    border-radius: 8px;
  }
}
</style>
